import React, { useEffect, useState } from "react";
import environment from "src/environment";
import { IProduct } from "src/types/product";
import styled from "styled-components";

import theme from "../../theme";
import MiniProductsCarousel from "../MiniProductsCarousel";

import useT2sProducts from "./useT2sProducts/useT2sProducts";

const Wrapper = styled.div``;

const Title = styled.h2`
  text-align: center;
  margin: ${theme.margins.marginBig} auto;
  font-family: ${theme.fonts.regular};
  font-weight: 300;
  font-size: 22px;
  letter-spacing: 1.8px;
  line-height: 1.3;
  text-transform: uppercase;
  padding: 0 ${theme.margins.paddingPageBig};

  &&:after {
    content: "";
    background-color: #000;
    width: 100%;
    max-width: 150px;
    height: 1px;
    display: block;
    margin: 10px auto 0 auto;
  }
`;

interface IOptions {
  spaceId: string;
  className?: string;
  title?: string;
  dots?: boolean;
  showPrice?: boolean;
  showRating?: boolean;
  maxSlides?: string;
}
export interface IProps {
  options: IOptions;
}

const T2sSlider = ({ options }: IProps): JSX.Element | null => {
  const {
    spaceId,
    className,
    title,
    dots,
    showPrice,
    showRating,
    maxSlides,
  } = options;

  const { t2sProducts, onT2SProductClicked } = useT2sProducts({ spaceId });
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    if (t2sProducts) {
      setProducts(
        t2sProducts.map((product) => ({
          ...product,
          displayPrice: showPrice,
          displayRating: showRating,
        }))
      );
    }
  }, [showPrice, showRating, t2sProducts]);

  return (
    <>
      <div id={`${environment.T2S.CID}-${spaceId}`} className="t2s-container" />

      {products.length && (
        <Wrapper className={className}>
          {title && <Title>{title}</Title>}
          <MiniProductsCarousel
            products={products}
            onClick={onT2SProductClicked}
            dots={dots}
            maxSlides={maxSlides}
          />
        </Wrapper>
      )}
    </>
  );
};

export default T2sSlider;
